import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-mandeep',
  templateUrl: './mandeep.component.html',
  styleUrls: ['./mandeep.component.scss']
})
export class MandeepComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getMandeep();
  }

}
